import React from 'react';

export default function Card({
	                             cardTitle,
	                             cardAction,
	                             children,
	                             className,
	                             ...restOfProps
                             }) {
	return (
		<div
			className={`card ${className}`}
			{...restOfProps}
		>
			<div className='card-content'>
				{!!cardTitle && <div className='card-title'>
					{cardTitle}
				</div>
				}
				<div>{children}</div>
			</div>
			{!!cardAction &&
			<div className='card-action'>
				{cardAction}
			</div>
			}
		</div>
	);
}